<template>
    <div class="page">
      <main-menu-bar/>
      <div class="page-inner">
        <screenshots-manager v-if="hasAccess"/>
        <access-denied-error v-else/>
      </div>
    </div>
</template>

<script>
import ScreenshotsManager from './ScreenshotsManager'
import MainMenuBar from '../nav/MainMenuBar.vue'
import AccessDeniedError from '../errors/AccessDeniedError.vue'
// import Role from '../../enums/role'

export default {
  name: 'ScreenshotsManagerPage',
  components: {
    ScreenshotsManager,
    MainMenuBar,
    AccessDeniedError
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  computed: {
    hasAccess () {
      if (!this.$store.getters['auth/authenticated']) {
        return false
      }
      return true
      /**
      return this.$store.getters['auth/user'].hasRole([
        Role.OPERATOR,
        Role.ADMIN
      ])
      **/
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/screenshots/ScreenshotsManagerPage.vue